import { Link } from "react-router-dom";
import styled from "styled-components";

export const NavigationBar = styled.ul`
  @media (max-width: 1023px) {
    display: none;
  }

  height: 135px;
  position: absolute;
  top: 0;
  right: 2rem;
  display: flex;
  align-items: center;
`;

export const Page = styled(Link)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 1rem;
  border-left: 1px solid var(--secondary-color);
  color: var(--secondary-color);
  @media (min-width: 1250px) {
    font-size: 1.2rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  :first-child {
    border: none;
  }
  :link {
    text-decoration: none;
  }
  :visited {
    color: var(--secondary-color);
  }
  :hover {
    color: var(--tertiary-color-main-buttons);
  }
  &.unitHabits,
  &.guests,
  &.products_services,
  &.colaborators,
  &.dashboard,
  &.login,
  &.about_us {
    color: var(--tertiary-color-main-buttons);
    font-weight: bold;
  }
`;
